import api, { TOKEN_KEY } from '@/api/axios'
import { ref } from 'vue'

const user = ref(null)
const isAuthed = ref(!!localStorage.getItem(TOKEN_KEY))

async function login(username, password) {
  // Expecting Django endpoint: POST api-token/ -> { token: "..." }
  const { data } = await api.post('api-token/', { username, password })
  if (!data?.access) throw new Error('No token in response')
  //console.log('Login response', data)

  localStorage.setItem(TOKEN_KEY, data.access)
  //console.log('Stored token', data.access)
  isAuthed.value = true
  // Optional: fetch user profile if you have /user/
  try {
    const me = await api.get('user/')
    user.value = me.data
  } catch { /* ignore */ }
}

async function verifyToken() {
  const token = localStorage.getItem(TOKEN_KEY)
  //console.log('Verifying token', token)
  if (!token) return false
  try {
    await api.get('verifytoken/')
    isAuthed.value = true
    return true
  } catch {
    logout()
    return false
  }
}

function logout() {
  localStorage.removeItem(TOKEN_KEY)
  isAuthed.value = false
  user.value = null
}

export function useAuth() {
  return { user, isAuthed, login, logout, verifyToken }
}
